// extracted by mini-css-extract-plugin
export default {"linkSignIn":"RegistrationClient_linkSignIn__GWH3U"};